<mat-card mat-ripple class="btn-inner-card mat-mdc-elevation-specific mat-elevation-z12" [ngClass]="{'controller-inner-card': isController}"
  (mousedown)="startPress(pattern.id, $event)" (mouseup)="endPress()" (mouseleave)="endPress()"
  (touchstart)="startPress(pattern.id, $event)" (touchend)="endPress()" (contextmenu)="$event.preventDefault(); $event.stopPropagation()"
  >
  <mat-progress-bar mode="determinate" *ngIf="isHoldingPress" [value]="pressProgress" class="progress-bar"></mat-progress-bar>
  <mat-card-header class="align-content-center">

    <mat-card-title class="align-content-center">
      <mat-icon><span class="material-icons">{{pattern.icon}}</span></mat-icon>
    </mat-card-title>
    <mat-card-subtitle class="align-content-center">{{pattern.name}}</mat-card-subtitle>

  </mat-card-header>
  <mat-card-actions style="font-size: x-small;" class="align-content-center">
    <mat-icon class="interval-bell-icon">notifications</mat-icon>
    <!-- {{pattern.pattern.join(',')}} -->
    <ng-container *ngFor="let interval of pattern.pattern">
      <span>{{ interval }}</span>
      <mat-icon  class="interval-bell-icon">notifications_notificationsactive</mat-icon>
    </ng-container>
  </mat-card-actions>
</mat-card>
